import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { Company, ICompany } from './Company'
import { AddressMapper } from '../Address/AddressMapper'

export class CompanyMapper implements ICollectionMapper<Company> {
  map(data: ICompany): Company {
    const company = new Company(data.name, data.type)
    company.id = data.id
    company.status = data.status
    company.identifier = data.identifier
    company.users = data.users
    company.admins = data.admins
    company.userRoles = data.userRoles
    company.features = data.features || []
    company.preferred = data.preferred
    company.adminCompanyId = data.adminCompanyId
    company.productTypes = data.productTypes
    company.subscriptionId = data.subscriptionId
    company.restaurantLimit = data.restaurantLimit

    if (data.externalIds) {
      company.externalIds = data.externalIds
    }

    if (data.address) {
      company.address = ( new AddressMapper() ).map(data.address)
    }

    return company
  }

  serialize(object: Company): ICompany {
    return JSON.parse(JSON.stringify(object))
  }
}
